<template>
	<el-container class="register-view">
        <div class="w-box">
			<img class="w-logo" src="../assets//image//logo-text.png" />
		</div>
        <div>
            <el-form class="login-form" :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="60px" @keyup.enter.native="submitForm('loginForm')">
                <div class="login-brand">
                    <!-- <img class="logo" src="../../public/logo.png" /> -->
                    <div>欢迎登录</div>
                </div>
                <el-form-item label="终端" prop="userName" v-show="false">
                    <el-input type="terminal" v-model.trim="loginForm.terminal" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="userName">
                    <el-input type="userName" v-model.trim="loginForm.userName" autocomplete="off" placeholder="用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password" style="margin-bottom: 0 !important;">
                    <el-input type="password" v-model.trim="loginForm.password" autocomplete="off" placeholder="密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <div class="forgot-password">
                        <el-checkbox v-model="checked" class="login-checkbox">记住密码</el-checkbox>
					    <!-- <span style="color: #666666;">没有账号,<router-link class="register-link" to="/register">立即注册</router-link></span> -->
                        <router-link class="register-link" style="color: #666666; font-size: 14px; text-decoration: underline;" to="/forgot">忘记密码</router-link>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="login-btn" type="primary" @click="submitForm('loginForm')">登录</el-button>
                </el-form-item>
                <div class="register">
					<span style="color: #666666;">没有账号,<router-link class="register-link" to="/register">立即注册</router-link></span>
				</div>
            </el-form>
        </div>
        <!-- <icp></icp> -->
	</el-container>
</template>

<script>
    import { encryptPassword, decryptPassword } from '../utils/index'
    import { initRsaPublicKey, rsaEncryptPassword } from '../utils/encrypt';
    import Icp from '../components/common/Icp.vue';
    export default {
        name: 'login',
        components: {
            Icp
        },
        data() {
            var checkUsername = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入用户名'));
                }
                if (/\s/.test(value)) {
                    return callback(new Error('用户名不能包含空格'));
                }
                callback();
            };
            var checkPassword = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }
                if (/\s/.test(value)) {
                    return callback(new Error('用户名不能包含空格'));
                }
                callback();
            };
            return {
                checked:true,
                loginForm: {
                    terminal: this.$enums.TERMINAL_TYPE.WEB,
                    userName: '',
                    password: ''
                },
                rules: {
                    userName: [
                        {
                            validator: checkUsername,
                            trigger: ['blur', 'change']
                        }
                    ],
                    password: [
                        {
                            validator: checkPassword,
                            trigger: ['blur', 'change']
                        }
                    ]
                }
            };
        },
        methods: {
            async submitForm(formName) {
                this.$refs[formName].validate( async (valid) => {
                    if (valid) {
                        await initRsaPublicKey()
                        this.$http({
                            url: '/login',
                            method: 'post',
                            data: {
                                publicKey: this.$store.state.userStore.PublicKey,
                                terminal: this.loginForm.terminal,
                                userName: this.loginForm.userName,
                                password: rsaEncryptPassword(this.loginForm.password)
                            }
                        }).then((data) => {
                            // 保存加密密码到localStorage
                            if(this.checked){
                                this.setStorage('username', this.loginForm.userName);
                                this.setStorage('password', encryptPassword(this.loginForm.password));
                            }
                            // 保存token
                            sessionStorage.setItem('accessToken', data.accessToken);
                            sessionStorage.setItem('refreshToken', data.refreshToken);
                            this.$message.success('登录成功');
                            this.$router.push('/home/chat');
                        });
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getStorage(name) {
                return localStorage.getItem(name);
            },
            setStorage(name, value) {
                localStorage.setItem(name, value);
            }
        },
        mounted() {
            this.loginForm.userName = this.getStorage('username');
            this.loginForm.password = decryptPassword(this.getStorage('password'));
        }
    };
</script>

<style scoped lang="scss">
    .register-view {
        position: fixed;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 10% 5%;
        background: rgb(232, 242, 255);
        background-size: cover;
        background-image: url('../assets//image//bg.png');

        .login-form {
		    width: 450px;
            padding: 35px 30px;
            background: white;
            opacity: 0.9;
            box-shadow: 0px 0px 1px #ccc;
            border-radius: 3%;
            overflow: hidden;
            border: 1px solid #ccc;

            .login-brand {
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 50px;
                margin: 30px 0 40px 0;
                font-size: 22px;
                font-weight: 600;
                letter-spacing: 2px;
                text-transform: uppercase;
                text-align: center;

                .logo {
                    width: 45px;
                    height: 45px;
                    margin-right: 10px;
                }
            }

            .login-checkbox{
                display: inline-block;
            }
            .login-btn{
                width: 100%;
                background: #1777ff;
                height: 40px;
                border: none;
            }
            .login-btn:hover{
                background: #0d65df;
            }

            .register {
                display: flex;
                justify-content: flex-end;
            }
        }
    }
    .forgot-password{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
    }

    .register-link{
        color: #3081fe;
        text-decoration: none;
    }

    .w-box{
        display: flex;
        align-items: center;
        position: absolute;
        top: 0px;
        left: 0px;

        .w-logo{
            height: 80px;
        }
    }

    ::v-deep .el-checkbox .el-checkbox__inner {
        border-radius: 4px !important; /* 强制方形 */
        width: 16px;
        height: 16px;
    }
    ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: #2973e0;
        border-color: #2973e0;
    }
    ::v-deep .el-input__inner{
        background: #f5f5f5;
    }
</style>
